module.exports = __webpack_public_path__ + "img/pakiet-2026.459f84fd.png";